import React from "react";
import { motion } from "framer-motion";
import { scorePassword } from "@/lib/passwords";

export default function PasswordStrength({ value }) {
  const { score, label, color } = scorePassword(value || "");
  const segments = 4;
  return (
    <div data-testid="password-strength-meter">
      <div className="flex gap-1.5">
        {Array.from({ length: segments }).map((_, i) => (
          <motion.div
            key={i}
            className="strength-seg"
            initial={false}
            animate={{
              backgroundColor: i < score ? color : "var(--vault-strength-empty)",
            }}
            transition={{ type: "spring", stiffness: 220, damping: 22 }}
          />
        ))}
      </div>
      <div className="mt-1 flex items-center justify-between">
        <span className="text-xs tracking-[0.05em] uppercase text-[color:var(--vault-text-tertiary)]">
          Strength
        </span>
        <span
          data-testid="password-strength-label"
          className="text-xs font-medium"
          style={{ color }}
        >
          {label}
        </span>
      </div>
    </div>
  );
}
